import getClientConfigValue from "../../../client/getClientConfigValue";
import config from "../../../config/common";

const {
  api: {
    serviceBanner: { path },
  },
} = config;

const getServiceBannerApiBaseUrl = () => {
  const baseUrl = SERVER
    ? process.env.CATEGORY_API_HOSTNAME
    : getClientConfigValue("BASE_URL");

  return `${baseUrl}${path}`;
};

export default getServiceBannerApiBaseUrl;
